import React from "react";

const SMALL_WORDS = new Set(["a", "an", "and", "as", "at", "but", "by", "for", "from", "in", "nor", "of", "on", "or", "per", "the", "to", "via", "with"]);

export function toTotoLabelCase(value = "") {
  const words = String(value).trim().split(/\s+/);

  return words.map((word, index) => {
    if (!word) return word;
    if (/^[A-Z0-9]{2,5}$/.test(word)) return word;

    const lower = word.toLowerCase();
    const isEdge = index === 0 || index === words.length - 1;
    if (!isEdge && SMALL_WORDS.has(lower)) return lower;

    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }).join(" ");
}

export default function TotoLabel({ children, style, ...props }) {
  const text = typeof children === "string" ? toTotoLabelCase(children) : children;

  return (
    <div
      {...props}
      style={{
        fontFamily: '"Outfit",system-ui,-apple-system,BlinkMacSystemFont,sans-serif',
        fontSize: 13,
        lineHeight: 1.15,
        fontWeight: 400,
        fontVariantCaps: "small-caps",
        letterSpacing: ".055em",
        color: "#505a52",
        ...style,
      }}
    >
      {text}
    </div>
  );
}
